import {BehaviorSubject} from "rxjs";
import {DimensionComponentObject, DimensionComponentObjects} from "./dimension-component-object";
import {MetricComponentObject, MetricComponentObjects} from "./metric-component-object";
import {DataSetDimension} from "../interfaces/dimensions";
import {DataSetMetric} from "../interfaces/metrics";

export class CustomImportMappingItemComponentObject {
  public readonly payload: any;

  public readonly type$: BehaviorSubject<'dimension' | 'metric'> = new BehaviorSubject<'dimension' | 'metric'>(null);
  public readonly name$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public readonly item$: BehaviorSubject<DimensionComponentObject | MetricComponentObject> = new BehaviorSubject<DimensionComponentObject | MetricComponentObject>(null);
  public readonly ext_format$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly number_format$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(payload: any) {
    this.payload = payload;
  }

  public initDimensions(generalDimensions: DimensionComponentObjects, dimensions: DimensionComponentObjects): void {
    if (this.payload.date) {
      this.item$.next(generalDimensions.find((item: DimensionComponentObject): boolean => (item.payload.attributes as DataSetDimension).slug === 'day'));
    } else {
      this.item$.next(dimensions.find((item: DimensionComponentObject): boolean => (item.payload.attributes as DataSetDimension).data_source_dimension_id === this.payload.id));
    }

    if (this.payload.ext_format) {
      this.ext_format$.next(this.getDateFormat(this.payload.ext_format));
    }
  }

  public initMetrics(metrics: MetricComponentObjects): void {
    this.item$.next(metrics.find((item: MetricComponentObject): boolean => (item.payload.attributes as DataSetMetric).data_source_metric_id === this.payload.id));

    if (this.payload.ext_format) {
      this.ext_format$.next(this.getNumberFormat(this.payload.ext_format.tsd_sep, this.payload.ext_format.dec_sep));
    }
  }

  private getDateFormat(format: string): string {
    switch (format) {
      case '%Y-%m-%d':
        return 'yyyy-mm-dd';
      case '%d-%m-%Y':
        return 'dd-mm-yyyy';
      case '%m-%d-%Y':
        return 'mm-dd-yyyy';
      case '%Y/%m/%d':
        return 'yyyy/mm/dd';
      case '%d/%m/%Y':
        return 'dd-mm-yyyy';
      case '%m/%d/%Y':
        return 'mm-dd-yyyy';
      default:
        return null;
    }
  }

  private getNumberFormat(thd_sep: string, dec_sep: string): string {
    if (thd_sep === 'null' && dec_sep === '.') {
      return '1234.56';
    } else if (thd_sep === 'null' && dec_sep === ',') {
      return '1234,56';
    } else if (thd_sep === ',' && dec_sep === '.') {
      return '1,234.56';
    } else if (thd_sep === '.' && dec_sep === ',') {
      return '1.234,56';
    } else if (thd_sep === 'space' && dec_sep === '.') {
      return '1 234.56';
    } else if (thd_sep === 'space' && dec_sep === ',') {
      return '1 234,56';
    } else if (thd_sep === 'space' && dec_sep === 'null') {
      return '1 234 (no decimal)';
    } else if (thd_sep === 'null' && dec_sep === 'null') {
      return '1234 (no decimal)';
    } else if (thd_sep === ',' && dec_sep === 'null') {
      return '1,234 (no decimal)';
    } else if (thd_sep === '.' && dec_sep === '%') {
      return '12.34%';
    } else if (thd_sep === ',' && dec_sep === '%') {
      return '12,34%';
    } else if (thd_sep === '.' && dec_sep === 'null') {
      return '0.1234';
    } else if (thd_sep === ',' && dec_sep === 'null') {
      return '0,1234';
    }

    return null;
  }
}
